import Vue from 'vue';
import Vuex from 'vuex';
import vuexI18n from 'vuex-i18n';
import toastr from "mini-toastr";
toastr.init();

Vue.use(Vuex);


const store = new Vuex.Store({
    state: {
        dimension: {},
        filter: {},
        menu: {},
        modul: '-',
        prevRoute: {},
        taskcount: 0,
        user: {},
        timeServer: '',
        notifications: [],
        dashboard: {},
        notifbadge: 0,
        notifbadgeList: [],
        promocsv: '',
        openOrder: 0,
        soldOut: 0,
        kitchenJob: 0,
        tableUsage: 0,
        progessupload: {
            value: 50,
            max: 100,
            show: true
        },
        backgroundprocessreport: {
            collectionreportbyloan: 'idle',
            collectionreportbydebitur: 'idle',
            collectionreport: 'idle',
            tanggal: '',
            data: {}
        },
        webloannotification: '',
        curLanguage: 'id',
        languages: [
            {
                short: 'en',
                long: 'English'
            },
            {
                short: 'id',
                long: 'Indonesian'
            }
        ]
    },
    mutations: {
        dimension(state, value) {
            state.dimension = value;
        },
        filter(state, value) {
            state.filter = value;
        },
        modul(state, value) {
            state.modul = value;
        },
        menu(state, value) {
            state.menu = value;
        },
        prevRoute(state, value) {
            state.prevRoute = value;
        },
        taskcount(state, value) {
            state.taskcount = value;
        },
        user(state, value) {
            state.user = value;
        },
        timeServer(state, value) {
            state.timeServer = value;
        },
        webloannotification(state, value) {
            state.webloannotification = value;
        },
        notifications(state, value) {
            state.notifications = value;
        },
        dashboard(state, value) {
            state.dashboard = value;
        },
        notifbadge(state, value) {
            state.notifbadge = value;
        },
        notifbadgeList(state, value) {
            state.notifbadgeList = value;
        },
        progessupload(state, value) {
            state.progessupload = value;
        },
        backgroundprocessreport(state, data) {
            state.backgroundprocessreport[data.key] = data.value;
            state.backgroundprocessreport.tanggal = data.tanggal;
            if (data.data) {
                state.backgroundprocessreport.data = data.data;
            }
        },
        translator(state, value) {
            state.translator = value;
        },
    },
    actions: {
        "SOCKET_dashboard"({ commit }, value) {
            commit('dashboard', value);
        },
        "SOCKET_notifbadge"({ commit }, value) {
            const { dataNotifMsg } = value;
            if (dataNotifMsg) {
                commit('notifbadge', dataNotifMsg.count);
                commit('notifbadgeList', dataNotifMsg.listnotifname);
            }
        },
        "SOCKET_progessupload"({ commit }, obj) {
            commit('progessupload', obj);
        },
        "SOCKET_backgroundprocessreport"({ commit }, obj) {
            commit('backgroundprocessreport', obj);
        },
        "SOCKET_backgroundprocessexportreport"({ commit }, response) {
            console.log('response',response);
            // const url = window.URL.createObjectURL(new Blob([response.data]));
            // const link = document.createElement('a');
            // link.href = url;
            // link.setAttribute('download', response.filename);
            // document.body.appendChild(link);
            // link.click();
            // resolve(link);
            // commit('backgroundprocessreport', obj);   
        },
        "SOCKET_timeserver"({ commit }, value) {
            commit('timeServer', value.timeServer);
        },
        "SOCKET_webloannotification"({ commit }, value) {
            commit('webloannotification', value.msg);
        },
        "SOCKET_translator"({ commit }, value) {
            Vue.i18n.add('en', value.en);
            Vue.i18n.add('id', value.id);
            Vue.i18n.set('id');
        },


    }
})

Vue.use(vuexI18n.plugin, store);

export default store;